import React from "react";
import { ArrowRightIcon } from "lucide-react";

export default function InfoCard({ title, description, onClick, icon }) {
    return (
        <div className="group flex h-full flex-col rounded-2xl bg-white p-5 shadow-[0_0_0_1px_var(--hairline)] hover:shadow-[0_0_0_1px_rgba(240,89,65,0.45)]">
            <div className="mb-4 flex h-10 w-10 items-center justify-center text-secondary">
                {icon}
            </div>
            <h3 className="font-Mulish text-lg font-semibold text-secondary">
                {title}
            </h3>
            <p className="mt-2 flex-1 font-Mulish text-sm leading-relaxed text-graphite">
                {description}
            </p>
            <button
                type="button"
                onClick={onClick}
                className="mt-4 inline-flex w-fit items-center gap-1.5 rounded-full border border-primary-200 bg-white px-4 py-2 font-Mulish text-sm text-primary-700 hover:bg-primary-50"
            >
                Try now
                <ArrowRightIcon className="h-4 w-4" />
            </button>
        </div>
    )
}
